import { formatCurrency, getCurrencySymbol } from '../helpers/currency';

export default {
    computed: {
        placeCurrency() {
            const place = this.$store && this.$store.state ? this.$store.state.place : null;
            return place && place.currency ? place.currency : 'BRL';
        },
        placeLocale() {
            const place = this.$store && this.$store.state ? this.$store.state.place : null;
            return place && place.locale ? place.locale : null;
        },
        currencySymbol() {
            return getCurrencySymbol(this.placeCurrency, this.placeLocale);
        },
    },
    methods: {
        formatCurrency(value, currency = null, locale = null) {
            return formatCurrency(
                value,
                currency || this.placeCurrency,
                locale || this.placeLocale,
            );
        },
        currencySymbolFor(currency) {
            return getCurrencySymbol(currency || this.placeCurrency, this.placeLocale);
        },
    },
};
